import Link from 'common/components/Link';
import Text from 'common/components/Text';
import Container from 'common/components/UI/Container';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { PiArticle, PiEnvelopeSimple, PiGlobe } from 'react-icons/pi';
import {
	FooterBottom,
	FooterNav, SocialLinks
} from './footer.style';

const Footer_Bottom = (props) => {
	const data = useStaticQuery(graphql`
  query {
		appJson {
			footer {
				copyright
				nav {
					link
					id
					title
				}
				socialLinks {
					iconName
					id
					label
					link
				}
			}
		}
  }
  `);

  const { appJson: footer } = data;

  const items = footer?.footer;

  const { copyright, nav, socialLinks } = items || {}
  const socialIcons = {
    blog: PiArticle,
    email: PiEnvelopeSimple,
    website: PiGlobe,
  };

  return (
		<Container {...props}>
			<FooterBottom>
				<Text content={copyright} />
				<FooterNav>
					{nav?.map((item, index) => (
						<li key={index}>
							<Link href={item?.link}>{item.title}</Link>
						</li>
					))}
				</FooterNav>
				<SocialLinks>
					<span>Furbuz:</span>
					{socialLinks?.length ?
					<ul>
						{socialLinks?.map((item) => {
							const SocialIcon = socialIcons[item?.iconName] || PiGlobe;
							return (
								<li key={item?.id}>
									<Link href={item?.link} aria-label={item?.label}>
										<SocialIcon aria-hidden="true" />
									</Link>
								</li>
							);
						})}
					</ul>
					:
					""
					}
				</SocialLinks>
			</FooterBottom>
		</Container>
  );
};

export default Footer_Bottom;
